export const isCpf = (content: string): boolean => {
    if (!content) return false

    content = content.replace(/\D+/g, '')

    if (content.length != 11) return false

    const pesoCPF: number[] = [11, 10, 9, 8, 7, 6, 5, 4, 3, 2]

    const calc = (str: string, peso: number[]) => {
        let soma: number = 0

        for (
            let indice = str.length - 1, digito: number;
            indice >= 0;
            indice--
        ) {
            digito = parseInt(str.substring(indice, indice + 1))
            soma += digito * peso[peso.length - str.length + indice]
        }

        soma = 11 - (soma % 11)
        return soma > 9 ? 0 : soma
    }

    for (let i = 1; i < 12; i++) {
        if (`${i}`.repeat(10) === content) {
            return false
        }
    }

    const digito1: number = calc(content.substring(0, 9), pesoCPF)
    const digito2: number = calc(content.substring(0, 9) + digito1, pesoCPF)

    return (
        content ===
        content.substring(0, 9) + digito1.toString() + digito2.toString()
    )
}

export const isCnpj = (value: string): boolean => {
    if (!value) return false

    value = value.replace(/\D+/g, '')

    const isString = typeof value === 'string'
    const validTypes =
        isString || Number.isInteger(value) || Array.isArray(value)

    if (!validTypes) return false

    if (isString) {
        if (value.length > 18) return false

        const digitsOnly = /^\d{14}$/.test(value)
        const validFormat = /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/.test(value)

        if (!digitsOnly && !validFormat) return false
    }

    const match = value.toString().match(/\d/g)
    const numbers = Array.isArray(match) ? match.map(Number) : []

    if (numbers.length !== 14) return false

    const items = [...new Set(numbers)]
    if (items.length === 1) return false

    const calc = (x: number) => {
        const slice = numbers.slice(0, x)
        let factor = x - 7
        let sum = 0

        for (let i = x; i >= 1; i--) {
            const n = slice[x - i]
            sum += n * factor--
            if (factor < 2) factor = 9
        }

        const result = 11 - (sum % 11)

        return result > 9 ? 0 : result
    }

    const digits = numbers.slice(12)

    const digit0 = calc(12)
    if (digit0 !== digits[0]) return false

    const digit1 = calc(13)
    return digit1 === digits[1]
}
